import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import _ from 'lodash';
import { UserAddressListItem } from './user-address-list-item';
import { layoutDefaults } from '../../utils/layout-defaults';

const maxItems = 5;

function SelectAddressModalBody({
  addresses,
  onSelect,
  onDelete,
  onNewAddressClick,
}) {
  const [loadingSelection, setLoadingSelection] = useState(false);
  const classes = useStyles();

  const handleOnSelectAddress = async (address, setLoading) => {
    setLoading(true);
    setLoadingSelection(true);

    _.delay(async () => {
      await onSelect?.call(this, address, (loading) => {
        setLoading(loading);
        setLoadingSelection(loading);
      });
    }, layoutDefaults.keyboardDuration);
  };

  const handleOnSelectNewAddress = async (address, setLoading) => {
    setLoading(true);
    setLoadingSelection(true);

    _.delay(async () => {
      await onNewAddressClick?.call(this, setLoading);
    }, layoutDefaults.keyboardDuration);
  };

  return (
    <div className={classes.container}>
      {_.take(addresses, maxItems)?.map((address, index) => (
        <UserAddressListItem
          key={address.id}
          address={address}
          index={index}
          onSelect={handleOnSelectAddress}
          onDelete={onDelete}
          disabled={loadingSelection}
        />
      ))}

      <UserAddressListItem
        key="new"
        index={(addresses?.length ?? 0) + 1}
        onSelect={handleOnSelectNewAddress}
        disabled={loadingSelection}
      />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // border: '1px solid red',
  },
});

export { SelectAddressModalBody };
